import Masonry from "masonry-layout";
import { DOM } from '../const';

const { $document } = DOM;
const $boards = $('.board-grid');

const scale = 1.20;

const updateSingleBoard = ($board) => {
  const section = $board.closest('.section');
  section.addClass('full-width');

  const items = $board.find('.board-item');
  const itemWidth = items.first().width();
  const topPadding = section.find('.text-box').height() / 2;
  const boardWidth = section.width() + 200;
  const boardHeight = section.height() - topPadding;
  const amount = items.length;
  const amountOfColumns = 3
  const amountOfRows = Math.ceil(amount / amountOfColumns)
  const columnWidth = boardWidth / amountOfColumns;
  const variableWidth = columnWidth - itemWidth;
  const maxLeft = boardWidth - itemWidth;
  const previousLeft = null;
  const previoustop = null;

  let heighArrays = [];
  items.each(function (i, j) {
    const tempArray = {
      height: $(this).height(),
      item: $(this)
    };

    heighArrays.push(tempArray);
  })
  heighArrays = heighArrays.sort((a, b) => { return a.height - b.height })

  const columnNumber = 0;
  const rowNumber = 0;
  const iterator = 0;
  const columnSettings = {};

  let tempColumns = [];
  for(let $i = 0; $i < amountOfColumns; $i += 1) {
    tempColumns.push([]);
  }

  while(heighArrays.length > 0) {
    for(let $i = 0; $i < amountOfColumns && heighArrays.length > 0; $i += 1) {
      tempColumns[$i].push(heighArrays[0]);
      heighArrays.splice(0, 1);
    }

    for(let $i = 0; $i < amountOfColumns && heighArrays.length > 0; $i += 1) {
      tempColumns[$i].push(heighArrays[heighArrays.length - 1]);
      heighArrays.splice(heighArrays.length - 1, 1);
    }
  }

  tempColumns = tempColumns.sort(() => (Math.random() > .5) ? 1 : -1);
  let maxHeight = 0;
  $(tempColumns).each(function (i){
    const columnIndex = i;
    const rows = $(this).sort(() => (Math.random() > .5) ? 1 : -1);

    $(rows).each(function (j){
      let top = 0;
      for(let k = j-1; k >= 0; k -= 1) {
        top += rows[k].height
        top += 2*variableWidth
      }
      if (top > 0) {
        top -= Math.random() *  0.5 * variableWidth * ( (Math.random() > .5) ? 1 : -1);
      } else {
        top += Math.random() * variableWidth * ( (Math.random() > .5) ? 1 : -1) + 0.5 * variableWidth;
      }
      const $realItem = $(this)[0].item;
      $realItem.css('left', -250 + columnIndex * columnWidth + 0.5 * (Math.random() * variableWidth * ( (Math.random() > .5) ? 1 : -1)));
      $realItem.css('top', top + topPadding);

      const tempHeight = top + topPadding + $(this)[0].height + 2 * variableWidth ;

      if (tempHeight > maxHeight) {
        maxHeight = tempHeight;
      }
    })
  })

  section.css('min-height', `${maxHeight  }px`)
}
const mouseEffect = (e, section) => {
  const $section = section;
  const $grid = section.find('.board-grid');
  const test = $section[0].getBoundingClientRect();

  const y = test.top;
  const x = test.left;
  const {width, height} = test;
  const cursorX = e.clientX - x;
  const cursorY = e.clientY - y;
  let relativeMovementX = ((cursorX / width) * 100 - 50) * 2;
  let relativeMovementY = ((cursorY / height) * 100 - 50) * 2;
  relativeMovementX = -1 * relativeMovementX * scale * width / 1000
  relativeMovementY = -1 * relativeMovementY * scale * height / 1000

  $grid[0].style.setProperty('--x', `${relativeMovementX}px`);
  $grid[0].style.setProperty('--y', `${relativeMovementY}px`);
}

const initializePositions = () => {
  $boards.each(function (){
    $(this).closest('section').off('mousemove');
    if($(this).css('display') === 'block') {
      $(this)[0].style.setProperty('--scale', scale);
      $(this).closest('section').on('mousemove', function (e){
        mouseEffect(e, $(this));
      })
      updateSingleBoard($(this));
    } else {
      $(this)[0].style.setProperty('--scale', 1);
      $(this).closest('.section').removeClass('full-width');
    }
  })
}

const overview = () => {
  if ($boards) {
    initializePositions()
    $( window ).resize(function() {
      initializePositions()
    });
  }
};

export default overview;
